import React from "react";
import { getFullRoute } from "../../utils/helper";

function SEOHead({ NextHead, seoConfig }) {
  if (!seoConfig) return null;

  const { pageTitle, metaDescription, openGraph, canonicalTag } = seoConfig;
  const Head = NextHead || "head";
  return (
    <Head>
      {pageTitle && <title>{pageTitle}</title>}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {openGraph?.title && (
        <meta property="og:title" content={openGraph.title} />
      )}
      {openGraph?.description && (
        <meta property="og:description" content={openGraph.description} />
      )}
      {openGraph?.image && (
        <meta property="og:image" content={openGraph.image} />
      )}
      <link rel="canonical" href={canonicalTag || getFullRoute()} />
      <meta name="robots" content="noodp,noydir" />
    </Head>
  );
}

export default SEOHead;
